import ACTIONS from '../constants/actionsTypes';

const initialState = {
    list      : [],
    best      : [],
    error     : null,
    isLoading : false
};

export default (state = initialState, action = {}) => {
    const { type, data } = action;

    switch (type) {
        case ACTIONS.GET_PRODUCT_RECOMMENDATIONS_REQUEST:
            return {
                ...state,
                isLoading : true
            };
        case ACTIONS.GET_PRODUCT_RECOMMENDATIONS_SUCCESS:
            return {
                ...state,
                list      : data,
                isLoading : false
            };
        case ACTIONS.GET_PRODUCT_RECOMMENDATIONS_ERROR:
            return {
                ...state,
                error     : data,
                isLoading : false
            };

        case ACTIONS.GET_PRODUCT_BEST_REQUEST:
            return {
                ...state,
                isLoading : true
            };
        case ACTIONS.GET_PRODUCT_BEST_SUCCESS:
            return {
                ...state,
                best      : data,
                isLoading : false
            };
        case ACTIONS.GET_PRODUCT_BEST_ERROR:
            return {
                ...state,
                error     : data,
                isLoading : false
            };
        default:
            return state;
    }
};
